<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title||" "'/>
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
*{
  padding: 0;
  margin: 0;
}
table{
  border-collapse:collapse;
  border: 1px solid #ccc;
  height: 40px;
  min-height: 40px;
}
 td,tr,th{
    border: 1px solid #ccc;
    height: 40px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
}
  img{
    max-width: 100%!important;
    height: auto;
  }
</style>
